// extracted by mini-css-extract-plugin
module.exports = {"acronym":"Acronym_acronym__2OBMS"};